<template>
  <div
    :class="['loading-logo-wrap', { 'p-absolute': !isFullPage }]"
    v-if="active"
  >
    <div id="loading-logo2"></div>
    <v-overlay z-index="20" absolute />
  </div>
</template>

<script>
export default {
  name: "vLoading",
  props: {
    active: Boolean,
    isFullPage: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    instance: null,
  }),
  methods: {
    async getLottie(resolveFn) {
      return new Promise(async (resolve) => {
        resolveFn = resolveFn || resolve;
        if (window.lottie) {
          return resolveFn(window.lottie);
        }
        setTimeout(() => {
          this.getLottie(resolve);
        }, 50);
      });
    },
  },
  watch: {
    active: {
      immediate: true,
      async handler(val) {
        if (val) {
          if (this.instance) return;
          const lottie = await this.getLottie();
          this.instance = lottie.loadAnimation({
            container: document.getElementById("loading-logo2"),
            renderer: "svg",
            loop: true,
            autoplay: true,
            path: "/loading-spinner.json",
          });
        } else {
          this.instance && this.instance.destroy();
          this.instance = null;
        }
      },
    },
  },
};
</script>

.<style lang="scss">
.loading-logo-wrap {
  #loading-logo2 {
    height: 30rem;
    width: 30rem;
    z-index: 21;
  }
}
</style>